import ComparisonPage from './ComparisonPage';

export default function AcuityComparisonPage() {
  return <ComparisonPage competitorKey="acuity" competitorName="Acuity Scheduling" />;
}
